import { BakePauseController } from 'utils/core'

// 뷰어 전역 bake 일시정지 게이트(싱글턴). 뷰어의 모든 본문 변환(getSafeElement → styleToInlineStyleAsync)
// 이 이 하나의 게이트를 공유한다. host 가 에디터 탭 활성화 시 webObj.setBakePaused(true) 로 닫고,
// 'view' 탭 복귀 시 false 로 열어, 에디터 초기화 구간에 뷰어 bake 가 메인 스레드를 경합하지 않게 한다.
// 작업은 지연될 뿐 소멸하지 않으며(abort 와 독립), 재개 시 이어서 변환한다. BakePauseController 참고.
export const bakePauseGate = new BakePauseController()
